import React, { useState, useEffect } from "react";

import { useHistory } from "react-router-dom";

// Components imports
import NavigationBar from "../../components/common/NavigationBar";
import Pagination from "../../components/common/Pagination";

// Scss imports
import css from "./NotArchivedPapers.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
  getNotArchivedPagePapers,
  notArchivedPapersNumber,
} from "../../redux/actions/papersActions";
import { preparingForArchive } from "../../redux/actions/archiveActions";

interface NotArchivedPapersProps {}

const NotArchivedPapers: React.FC<NotArchivedPapersProps> = () => {
  const dispatch = useDispatch();

  let history = useHistory();

  // All page papers
  const notArchivedPapers = useSelector(
    (state: any) => state.papers.notArchivedPagePapers
  );

  // Array for generation table data
  const tableData =
    notArchivedPapers && notArchivedPapers.length > 0
      ? notArchivedPapers.map((element) => {
          const elementType = () => {
            if (element.paperType === "outgoing") {
              return "Долазни документ";
            } else if (element.paperType === "incoming") {
              return "Одлазни документ";
            } else {
              return "";
            }
          };

          return {
            baseNumber: element.baseNumber.baseNumber,
            subNumber: element.subnumber,
            createdAt: element.createdAt.split("T")[0],
            shortText: element.shortText,
            paperType: elementType(),
            recipientSender: element.recipientSender,
            "Број акта пошиљаоца":
              element.senderPaperNumber === "undefined"
                ? element.senderPaperNumber
                : "",
            "Датум акта пошиљаоца": element.senderDate
              ? element.senderDate.split("T")[0]
              : "",
            _id: element._id,
          };
        })
      : "";

  // All pages number
  const notArchivedPapersNumberShow = useSelector(
    (state: any) => state.papers.notArchivedPapersNumber
  );

  const [papersData, setPapersData] = useState([{}]);
  const [papers, setPapers] = useState("allUsers");
  const [pagesNumber, setPagesNumber] = useState(0);

  // Current active page
  const [activePage, setActivePage] = useState(1);

  // Page limit
  const [pageLimit, setPageLimit] = useState(10);

  const [rowsArray, setRowsArray] = useState<any>([]);

  // Fake table data
  const columns = [
    "Основни број",
    "Подброј",
    "Датум",
    "Кратак садржај",
    "Тип",
    "Пошиљалац",
    "Број акта пошиљаоца",
    "Датум акта пошиљаоца",
  ];

  const [notArchivedPapersIds, setNotArchivedPapersIds] = useState<any>([]);

  useEffect(() => {
    dispatch(getNotArchivedPagePapers(1, pageLimit));
    dispatch(notArchivedPapersNumber(`arhived=notarhived`));
  }, []);

  useEffect(() => {
    setPapersData(
      notArchivedPapers && notArchivedPapers.length > 0
        ? notArchivedPapers.map((element) => {
            const elementType = () => {
              if (element.paperType === "outgoing") {
                return "Долазни документ";
              } else if (element.paperType === "ingoing") {
                return "Одлазни документ";
              } else {
                return "";
              }
            };

            return {
              baseNumber: element.baseNumber.baseNumber,
              subNumber: element.subnumber,
              createdAt: element.createdAt.split("T")[0],
              shortText: element.shortText,
              paperType: elementType(),
              recipientSender: element.recipientSender,
              "Број акта пошиљаоца":
                element.senderPaperNumber === "undefined"
                  ? element.senderPaperNumber
                  : "",
              "Датум акта пошиљаоца": element.senderDate
                ? element.senderDate.split("T")[0]
                : "",
            };
          })
        : ""
    );
  }, [notArchivedPapers, papers]);

  useEffect(() => {
    setPagesNumber(Math.ceil(notArchivedPapersNumberShow / pageLimit));
  }, [notArchivedPapersNumberShow]);

  useEffect(() => {
    setPagesNumber(Math.ceil(notArchivedPapersNumberShow / pageLimit));
  }, [papers]);

  useEffect(() => {
    markSelectedRow();
  }, [notArchivedPapersIds]);

  useEffect(() => {
    setRowsArray([]);
    markSelectedRow();
  }, [notArchivedPapers]);

  useEffect(() => {
    markSelectedRow();
  }, [papersData]);

  const renderTr: any = (element) => {
    const elementObject = Object.keys(element);
    return elementObject.map((el) => {
      return el !== "_id" ? <td>{`${element[el]}`}</td> : "";
    });
  };

  // Function for marking selected rows
  const markSelectedRow = () => {
    const rowsNodeList = document.querySelectorAll("tr");
    setRowsArray(Array.from(rowsNodeList));

    rowsArray.forEach((row) => {
      if (notArchivedPapersIds.includes(row.dataset.id)) {
        row.classList.add(css.markedRow);
      } else {
        row.classList.remove(css.markedRow);
      }
    });
  };

  // On row click event
  const onRowClickEvent = (el: any) => {
    const elDataSet = el.target.parentNode.getAttribute("data-id");

    if (notArchivedPapersIds.includes(elDataSet)) {
      let filteredArray = notArchivedPapersIds.filter(
        (item) => item !== elDataSet
      );
      setNotArchivedPapersIds(filteredArray);
    } else {
      setNotArchivedPapersIds([...notArchivedPapersIds, elDataSet]);
    }
  };

  // Prepare for archive event
  const prepareForArchivingEvent = () => {
    dispatch(preparingForArchive(notArchivedPapersIds, history));
  };

  return (
    <div className={css.container}>
      <NavigationBar
        type="notArchived"
        onClickEvent={prepareForArchivingEvent}
        notArchivedPapers={notArchivedPapers}
      />

      <div className={css.contentContainer}>
        {/* Title part */}
        <h1>Неархивирана документа</h1>
        {notArchivedPapers && notArchivedPapers.length > 0 ? (
          <p className={css.text}>Чекирај документа за архивирање</p>
        ) : (
          <p className={css.greenText}>Немате неархивираних докумената</p>
        )}

        {/*Table */}
        {notArchivedPapers && notArchivedPapers.length > 0 && (
          <table className={`${css.table}`}>
            <thead>
              <tr>
                {columns.map(function (column) {
                  return <th>{column}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {tableData.map((element) => {
                return (
                  <tr
                    data-id={element._id}
                    onClick={(el: any) => {
                      onRowClickEvent(el);
                    }}
                  >
                    {renderTr(element)}
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
        {/* Pagination */}
        <Pagination
          pagesNumber={pagesNumber}
          papers={papers}
          activePage={activePage}
          setActivePage={setActivePage}
          pageLimit={pageLimit}
        />
      </div>
    </div>
  );
};

export default NotArchivedPapers;
